<template>
  <div class="register">

    <div class="steps">
      <div class="step">
        <div class="number"><i class="fas fa-user"></i></div>
        <div class="title">Personal data</div>
      </div>
      <div class="step">
        <div class="number"><i class="fas fa-tasks"></i></div>
        <div class="title">Preferences</div>
      </div>
      <div class="step active">
        <div class="number"><i class="fas fa-check"></i></div>
        <div class="title">Confirm</div>
      </div>
    </div>

    <div class="form">
      <div class="field">
        <label>Enter the confirmation code sent to {{ email }}</label>
        <input type="text" placeholder="Confirmation code..." v-model="code">
      </div>
      <div class="field">
        <a class="primary fluid button" @click="register()" :class="{ loading: loadingRegister }">Finish</a>
      </div>
    </div>

    <div class="error message" v-if="errors.messages.length > 0">
      <h4>The following errors occurred</h4>
      <ul>
        <li v-for="message in errors.messages" :key="message">{{ message }}</li>
      </ul>
    </div>

    <div class="message">
      <p>The account will be created when the mail is confirmed</p>
      <p>In the meantime <strong>do not close this window</strong></p>
    </div>

    <div class="form">
      <a class="fluid button" @click="sendConfirmation()" :class="{ loading: loadingSend }">Resend confirmation code</a>
    </div>
    
  </div>
</template>

<script>
import APIAccountService from '@/services/APIAccountService'
import ErrorService from '@/services/ErrorService'

export default {
  props: [ 'data' ],
  data () {
    return {
      code: '',
      loadingRegister: false,
      loadingSend: false,
      errors: ErrorService.init(),
    }
  },
  created () {
    if(!this.data.userChecked || !this.data.searchChecked) {
      this.$router.replace({ name: 'register' });
    } else {
      this.sendConfirmation();
    }
  },
  methods: {
    sendConfirmation () {
      this.loadingSend = true;
      APIAccountService.sendRegisterConfirmation({ name: this.data.user.name, email: this.data.user.email })
      .then(() => {
        this.loadingSend = false;
        this.errors = ErrorService.init();
      })
      .catch(response => {
        this.loadingSend = false;
        this.errors = ErrorService.process(response, this.translateError);
      });
    },
    register () {
      this.loadingRegister = true;
      APIAccountService.register({ ...this.data.user, ...this.data.search, code: this.code })
      .then(() => {
        this.loadingRegister = false;
        this.$router.replace({ name: 'register-done' }).catch(console.error);
      })
      .catch(response => {
        this.loadingRegister = false;
        this.errors = ErrorService.process(response, this.translateError);
      });
    },
    translateError (error) {
      switch(error) {
        case 'name must be a string': return 'Full name must not be empty';
        case 'name must not be empty': return 'Full name must not be empty';
        case 'email must be valid email': return 'Email is not valid';
        case 'email-unavailable': return 'Email is already in use';
        case 'password must contain only letters (a-z) and digits (0-9)': return 'Password must contain only letters (a-z) and digits (0-9)';
        case 'password must have a length between 8 and 20': return 'Password must have a length between 8 and 20';
        case 'terms is not considered as "True"': return 'Terms and conditions must be accepted';
        case 'code-incorrect': return 'Código de confirmación incorrecto';
        case 'code must contain only digits (0-9)': return 'Código de confirmación inválido';
        case 'code must have a length between 8 and 8': return 'Código de confirmación inválido';
        default: return error;
      }
    },
  },
  computed: {
    email() {
      return this.data.user.email;
    }
  },
}
</script>